<div class="driver-exercise-card">
  <div class="top-card">
    <div class="left-card" (click)="goToExercise()">
      <div class="icon">
        <mat-icon>event</mat-icon>
      </div>
      <div class="text">
        <div class="title">
          {{ exercise().title }}
          <mat-icon style="color: #2d3872">chevron_right</mat-icon>
        </div>
        <div class="subtitle">{{ exercise().dates }}</div>
      </div>
    </div>
    <div class="right-card">
      <app-vacation-switch [exerciseId]="exercise().id" [exerciseActive]="exercise().active"
        (statusChanged)="onStatusChanged()"></app-vacation-switch>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="bottom-card">
    <div class="bottom-information">
      @for(data of exercise().bottomCardData; track data.title){
      <div class="info-item">
        <div class="subtitle">{{ data.title }}</div>
        <div class="title">
          @if(data.title === 'NOTIFICACIONES' && data.value >= 1){
          <mat-icon>error</mat-icon>
          }
          {{ data.value }}
        </div>
      </div>
      }
    </div>
  </div>
</div>